import React from "react";

const NeueVerticalAlignBottomStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.00018 10.6H7.00002C6.11637 10.6 5.40002 9.88369 5.40002 9.00001V3.80001C5.40002 2.91636 6.11637 2.20001 7.00002 2.20001H9.00018C9.88386 2.20001 10.6002 2.91636 10.6002 3.80001V9.00001C10.6002 9.88369 9.88386 10.6 9.00018 10.6Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 13.8H13.8",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueVerticalAlignBottomStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;